const getImpersonationFromLS = () => {
  return {
    impersonate: sessionStorage.getItem('impersonate'),
    impersonateId: sessionStorage.getItem('impersonateId'),
    impersonateName: sessionStorage.getItem('impersonateName'),
  };
};

export default getImpersonationFromLS;
